import { useFetchCurrentUser } from '@/query/user.query';

import { useAuthStore } from '@/store/auth.store';

export function useCurrentUser() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const { data: userData, ...queryState } = useFetchCurrentUser({
    enabled: isAuthenticated,
  });

  return {
    userData,
    ...queryState,
  };
}
